import { Redirect } from "react-router-dom"
import styled from "styled-components"

import { breakpoint, spacing } from "@minuthq/meatball-ui-react"

import { mainContentPadding } from "src/components/AppLayout/sharedStyles"
import { MinutAIContentLibrary } from "src/components/MinutAI/MinutAIKnowledge/MinutAIContentLibrary/MinutAIContentLibrary"
import { MinutAIPreview } from "src/components/MinutAI/MinutAIKnowledge/MinutAIPreview/MinutAIPreview"
import { ScrollArea } from "src/components/ScrollArea/ScrollArea"
import { useFlags } from "src/hooks/useFlags"
import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { Container } from "src/ui/Container/Container"
import { Titlebar } from "src/ui/Layout/Titlebar"

export function MinutAIKnowledge() {
  const { enableCompass } = useFlags()

  const { tPlaceholder } = useTranslate()

  if (!enableCompass) {
    return <Redirect to={Routes.Dashboard.location()} />
  }

  return (
    <StyledContainer>
      <Titlebar title={tPlaceholder("Knowledge")} />

      <Main>
        <StyledScrollArea>
          <MinutAIContentLibrary />
        </StyledScrollArea>

        <ScrollArea>
          <MinutAIPreview />
        </ScrollArea>
      </Main>
    </StyledContainer>
  )
}

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  padding: ${mainContentPadding};
  height: 100vh;
  overflow: hidden;
`

const Main = styled.div`
  flex: 1;

  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.L};
  overflow: hidden;

  @container (${breakpoint.normalUp}) {
    grid-template-columns: 3fr 1fr;
  }

  @container (${breakpoint.largeUp}) {
    grid-template-columns: 4fr 1fr;
  }
`

const StyledScrollArea = styled(ScrollArea)`
  padding-right: ${spacing.S};
`
